<template>
  <v-container :style="{'max-width': vuetifyLargeWidth}">
    <v-row>
      <v-col>
        <FlexColumn>
          <Label size="h5" bold text="候補者管理" style="margin-top: 76px"/>

          <FlexRow align="baseline" class="mt-2 mb-6">
            <SimpleSelectField
                :value="filteredJob"
                :items="filteredJobs"
                simple width="320px"
                class="mt-0 pt-0"
                @input="handleSelectFilteredJob"
            />
            <Button
                v-for="item in filteredApplicationStatusItems"
                :key="item.value"
                small
                :color="item.value === filteredStatus ? 'primary' : undefined"
                @click="handleSelectFilteredStatus(item.value)"
            >
              {{item.label}}
            </Button>
          </FlexRow>

          <JobUserList :users="candidateUsers.results" @init="init" @sort="handleSort"/>
          <Pagination
              v-model="candidateUsersPage"
              :length="(Math.floor((candidateUsers.count - 1) / 10)) + 1"
              @change="changeCandidateUsersPage"
              class="mt-1"
          />
        </FlexColumn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import ComponentMixin from '../../../ComponentMixin';
  import { mapGetters } from "vuex";
  import JobUserList from "../../../organisms/JobUserList";
  import ApiMixin from "@/ApiMixin";
  import Pagination from "@/components/atoms/Pagination";
  import Label from '../../../atoms/Label'
  import FlexColumn from '../../../atoms/FlexColumn'
  import FlexRow from "../../../atoms/FlexRow";
  import SimpleSelectField from "../../../atoms/SimpleSelectField";
  import {jobApplicationStatus} from "../../../../enums"
  import Button from "../../../atoms/Button";

  export default {
    mixins: [ComponentMixin, ApiMixin],
    type: "page",
    name: "ClientCandidateTopPage",
    data () {
      return {
        tab: null,
        candidateUsersPage: 1,
        casualMeetingUsersUsersPage: 1,
        filteredJob: "all",
        filteredStatus: 99,
        sortedItem: "lastAppliedAt",
        sortedDirection: 'desc'
      }
    },
    components: {
      Button,
      SimpleSelectField,
      FlexRow,
      FlexColumn,
      Label,
      Pagination,
      JobUserList
    },
    computed: {
      ...mapGetters("user", ["user"]),
      ...mapGetters("client", ["company", "candidateUsers", "casualMeetingUsers", "jobs", "allJobs"]),
      lang() {
        return this.$i18n.locale
      },
      filteredJobs() {
        if (this.allJobs) {
          const jobs = this.allJobs.map(job => ({
            label: job.name,
            value: job.id
          }))
          jobs.unshift({
            label: "すべての求人",
            value: "all"
          })
          return jobs
        }
        return []
      },
      filteredApplicationStatusItems() {
        const items = [{
          value: 99,
          label: "選考中の全候補者"
        }]
        return items.concat(jobApplicationStatus.regular)
      },
      candidates() {
        return [{}]
      },
      vuetifyLargeWidth() {
        return '1264px'
      }
    },
    beforeMount() {
      this.fetchCandidateUsers();
      this.fetchJobs();
    },
    methods: {
      fetchCandidateUsers (page = 1, jobId = "all", applicationStatus = 99, sortedItem = 'lastAppliedAt', sortedDirection = 'desc') {
        if (this.user.business && this.company && this.company.id) {
          this.candidateUsersPage = page;
          this.filteredJob = jobId
          this.filteredStatus = applicationStatus
          this.sortedItem = sortedItem
          this.sortedDirection = sortedDirection
          this.loadCandidateUsers(
              this.company.id,
              page,
              jobId === "all" ? undefined : jobId,
              applicationStatus === 99 ? [2, 3, 4] : applicationStatus,
              sortedItem,
              sortedDirection
          );
        }
      },
      fetchJobs() {
        if (this.company && this.company.id) {
          this.loadAllClientJobs(this.company.id)
        }
      },
      changeCandidateUsersPage (page) {
        this.fetchCandidateUsers(page, this.filteredJob, this.filteredStatus, this.sortedItem, this.sortedDirection);
      },
      init () {
        this.fetchCandidateUsers(this.candidateUsersPage)
      },
      handleSelectFilteredJob(value) {
        this.fetchCandidateUsers(1, value, this.filteredStatus)
      },
      handleSelectFilteredStatus(value) {
        this.fetchCandidateUsers(1, this.filteredJob, value)
      },
      handleSort(item, direction) {
        this.fetchCandidateUsers(1, this.filteredJob, this.filteredStatus, item, direction)
      }
    },
    watch: {
      "company.id": {
        handler: function (value) {
          if (value) {
            this.fetchCandidateUsers();
            this.fetchJobs();
          }
        }
      }
    }
  }
</script>

<style scoped lang="sass">
</style>
